import Menu from './components/menu.js';
import Burger from './components/burger.js';
import DropDown from './components/ln-menu';
import Tabs from './lib/tabs.js';
import slick from 'slick-carousel';
import Newsletter from './components/newsletter.js';
import Form from './lib/form.js';
import ConsultAs from './components/consult-as.js';
import Password from './components/password.js';
import Products from './components/products';

(function () {

	DropDown();

	Tabs({
		prefix: 'brtn-tabs',
		action: 'hover'
	});

	Form({
		action: 'login',
		classNames: {
			form: 'brtn-popup-login__form--login',
			message: 'brtn-message'
		}
	});

	$('.brtn-slideshow--main').slick({
		arrows: true,
		dots: true,
		prevArrow: '<button class="brtn-slideshow__btn brtn-slideshow__btn--prev"><span class="brtn-icon brtn-icon--arrow-left"></span></button>',
		nextArrow: '<button class="brtn-slideshow__btn brtn-slideshow__btn--next"><span class="brtn-icon brtn-icon--arrow-right"></span></button>'
	});

	$('.brtn-slideshow--dflt').slick({
		arrows: true,
		dots: true,
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 2,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			},
		],
		prevArrow: '<button class="brtn-slideshow__btn brtn-slideshow__btn--prev"><span class="brtn-icon brtn-icon--arrow-left"></span></button>',
		nextArrow: '<button class="brtn-slideshow__btn brtn-slideshow__btn--next"><span class="brtn-icon brtn-icon--arrow-right"></span></button>'
	});

	$('.brtn-slideshow--prds').slick({
		arrows: true,
		dots: true,
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 3,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			},
		],
		prevArrow: '<button class="brtn-slideshow__btn brtn-slideshow__btn--prev"><span class="brtn-icon brtn-icon--arrow-left"></span></button>',
		nextArrow: '<button class="brtn-slideshow__btn brtn-slideshow__btn--next"><span class="brtn-icon brtn-icon--arrow-right"></span></button>'
	});

	Password();
	Menu();
	Burger();
	Newsletter();
	ConsultAs();
	Products();

})();